import { combineLatest, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Component, Watch } from 'vue-property-decorator';

import { Alias, AliasDataStore, aliasSelectors, Work, workSelectors } from '@skinsoft/entity';
import { ReactiveVue } from '@skinsoft/reactive-vue';

@Component({
    props: ['work', 'authorId'],
    template: require('./author.html'),
})
export class Author extends ReactiveVue {
    public work: Work;
    public authorId: string;

    public $aliasDataStore: AliasDataStore;
    public aliases: Alias[] = null as any;
    public aliasSelectors = aliasSelectors;
    public error: Error = null as any;

    public created() {
        this.subscribe();
    }

    private subscribe() {

        const aliasIds = this.work !== undefined ? workSelectors.aliases(this.work) : [this.authorId];
        if (!this.authorId || aliasIds.length === 0) {
            this.aliases = [];
            return;
        }

        this.subscribeTo(
            combineLatest<Alias>(
                aliasIds.map(aliasId => this.$aliasDataStore.fetchOne(aliasId)),
            ).pipe(
                catchError(error => {
                    // tslint:disable-next-line:no-console
                    console.error(error);
                    this.error = error;
                    return of([]);
                }),
            ),
            aliases => {
                this.aliases = aliases as Alias[];
            },
            'aliases',
        );
    }

    @Watch('work')
    private onWorkChange() {
        this.unsubscribeFrom('aliases');
        this.subscribe();
    }

    @Watch('aliases')
    private onAuthoritiesChange(value) {
        if (!value) {
            return;
        }

        this.$emit('ready');
    }
}
